/**
 * @generated SignedSource<<a9214006310adbbf4b3a6ae11465b5bd>>
 * @relayHash a58e91e977d5d5cc46f020445cdf0449
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7a8ce18747f7c43e470e295b40be152882a705890a15e0182e9d421dbfeb9609

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphStoreCreateProjectHasRelatedWorkWithProjectInput = {
  relationships: ReadonlyArray<GraphStoreCreateProjectHasRelatedWorkWithProjectRelationshipInput>;
};
export type GraphStoreCreateProjectHasRelatedWorkWithProjectRelationshipInput = {
  from: string;
  sequenceNumber?: AGG$Long | null | undefined;
  to: string;
  updatedAt?: AGG$DateTime | null | undefined;
};
export type useConnectProjectProjectHasRelatedWorkWithProjectCreateMutation$variables = {
  input?: GraphStoreCreateProjectHasRelatedWorkWithProjectInput | null | undefined;
};
export type useConnectProjectProjectHasRelatedWorkWithProjectCreateMutation$data = {
  readonly graphStore: {
    readonly createProjectHasRelatedWorkWithProject: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useConnectProjectProjectHasRelatedWorkWithProjectCreateMutation = {
  response: useConnectProjectProjectHasRelatedWorkWithProjectCreateMutation$data;
  variables: useConnectProjectProjectHasRelatedWorkWithProjectCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useConnectProjectProjectHasRelatedWorkWithProjectCreateMutation",
    "selections": [
      {
        "concreteType": "GraphStoreMutation",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "GraphStoreCreateProjectHasRelatedWorkWithProjectPayload",
            "kind": "LinkedField",
            "name": "createProjectHasRelatedWorkWithProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useConnectProjectProjectHasRelatedWorkWithProjectCreateMutation",
    "selections": [
      {
        "concreteType": "GraphStoreMutation",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "GraphStoreCreateProjectHasRelatedWorkWithProjectPayload",
            "kind": "LinkedField",
            "name": "createProjectHasRelatedWorkWithProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v4/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "7a8ce18747f7c43e470e295b40be152882a705890a15e0182e9d421dbfeb9609",
    "metadata": {},
    "name": "useConnectProjectProjectHasRelatedWorkWithProjectCreateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "2846b3362eafd7b13df7ab71229cd39c";

export default node;
